import React from 'react';
import { MBText } from '@shared/components/text';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MBBaseChatBanner } from './base';

interface MBMeChatBannerProps {
  user: MBAPI.ShortUser;
  channel: MBAPI.ChannelChatThread;
}

export function MBMeChatBanner({ user, channel }: MBMeChatBannerProps) {
  return (
    <MBBaseChatBanner title={channel.name} subtitle={`@${user.username}`} channel={channel}>
      <MBText color={Colors.v2.greenSecondary90}>{i18n('chat.banner.yourSpace')}</MBText>
    </MBBaseChatBanner>
  );
}
